import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';
import InformaticaList from './InformaticaList';

const InformaticaModule = {
    list: InformaticaList,
    icon: DesktopWindowsRoundedIcon,
}; export default InformaticaModule;